import { carBrandsLoader } from "../../loaders/laximo/carBrandsLoader";

/** Кейсы загрузки марок автомобилей */
export const carBrandsCases = (builder: any) => {
    builder
        .addCase(carBrandsLoader.pending, (state: any) => {
            state.loading.carBrands = true;
        })
        .addCase(carBrandsLoader.fulfilled, (state: any, action: any) => {
            state.carBrands = action.payload;
            state.loading.carBrands = false;
        })
        .addCase(carBrandsLoader.rejected, (state: any, action: any) => {
            state.error.carBrands = action.payload;
            state.loading.carBrands = false;
        });

    return builder;
}